export const images = [
  {
    preview:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&q=80",
    description: "Team planning and sketches",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=1200&q=80",
    description: "Light bulb and creative idea",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&q=80",
    description: "Coffee and workspace",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&q=80",
    description: "Modern office interior",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1200&q=80",
    description: "Creative workspace",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=1200&q=80",
    description: "Office meeting room",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80",
    description: "Laptop and coffee desk",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200&q=80",
    description: "Person working in sweater",
  },
  {
    preview:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=400&q=80",
    original:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200&q=80",
    description: "Presentation and audience",
  },
];
